<script setup lang="ts">
import type { GradeCode } from '~/models/Grade'
import { useI18n } from 'vue-i18n'
import { KsButton } from '@aschehoug/kloss'

const { options } = defineProps<{ options: GradeCode[] }>()
const selectedGrades = defineModel<GradeCode[]>()

const { t } = useI18n()
</script>

<template>
  <aside class="grid-in-filters">
    <form
      class="flex flex-col gap-2 rounded bg-white p-3"
      style="--ks-roundness: .2"
    >
      <KsButton
        type="label"
        size="small"
        :variant="Number(selectedGrades?.length) > 1 ? 'secondary' : 'tertiary'"
        class="!text-sm focus-within:ring"
      >
        <input
          v-model="selectedGrades"
          :value="options"
          type="radio"
          class="size-2 appearance-none rounded-full bg-white ring ring-blue-40 ring-offset-2 checked:bg-blue-40"
        >
        <span class="ml-2">{{ t('search.filters.allGrades') }}</span>
      </KsButton>
      <KsButton
        v-for="grade in options"
        :key="grade"
        :variant="selectedGrades?.every(g => g === grade) ? 'secondary' : 'tertiary'"
        type="label"
        class="!text-sm focus-within:ring"
      >
        <input
          v-model="selectedGrades"
          :value="[grade]"
          type="radio"
          class="size-2 appearance-none rounded-full bg-white ring ring-blue-40 ring-offset-2 checked:bg-blue-40"
        >
        <span class="ml-2">{{ t(`metadata.grades.${grade}`) }}</span>
      </KsButton>
    </form>
  </aside>
</template>
